import { ref } from 'vue'

const isNavigatorDrawerOpen = ref(false)

function toggleNavigatorDrawer() {
  isNavigatorDrawerOpen.value = !isNavigatorDrawerOpen.value
}

export default function () {
  return {
    toggleNavigatorDrawer,
    isNavigatorDrawerOpen,
  }
}
